import { render, staticRenderFns } from "./PickupPointInfo.vue?vue&type=template&id=c2171b26&scoped=true&"
import script from "./PickupPointInfo.vue?vue&type=script&lang=js&"
export * from "./PickupPointInfo.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointInfo.vue?vue&type=style&index=0&id=c2171b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2171b26",
  null
  
)

export default component.exports